// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getStorage, uploadBytes } from "firebase/storage"

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBcgL18IWm_w1NcTWoGZ9Lu1oc_MZRDeEk",
  authDomain: "imageuploader-dfb20.firebaseapp.com",
  projectId: "imageuploader-dfb20",
  storageBucket: "imageuploader-dfb20.appspot.com",
  messagingSenderId: "20147446128",
  appId: "1:20147446128:web:a632535ff0d5a2d37f6fb5",
  measurementId: "G-Y39EPD9MDY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics();

const storage = getStorage(app);
export default storage;